






import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import CountryService from '@/shared/services/country-service';
import HttpService from '@/shared/services/http-service';

import { IConfig } from '../models/config-viewmodel';
import { Message } from '@/shared/models/view/message-viewmodel';
import { Country } from '@/shared/models/view/country-viewmodel';

@Component({
    computed: {
        ...mapState(['form', 'config', 'countries'])
    }
})
export default class CountriesComponent extends Vue {
    public config!: IConfig;
    public countries!: Country[];

    mounted() {
        this.init();
    }

    private init() {
        if (this.countries.length <= 0) {
            this.loadData();
        }
    }

    private compare(a: any, b: any): number {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }

    private loadData() {
        this.$store.commit('setLoading', true);
        Promise.all([
            CountryService.getAllCountries(this.config.language, HttpService),
        ])
        .then(values => {
            if(values[0]) {
                this.$store.commit('setCountries', values[0].filter((country: Country) => country.name).sort(this.compare));
                this.$store.commit('setLoading', false);
            }
        })
        .catch(error => {
            console.log(error)
            this.$store.commit('root/setErrors', [
                this.config.language === 'nl' ? 
                    'Er gaat iets fout, probeer het later nog een keer' : 
                    'Something went wrong, please try again later'
            ]);
            this.$store.commit('setLoading', false);
        })
    }
}
